import {createDataStore} from './createDataStore';

// Caches /data/llmData.json for the LLM tutorial pages.
// See createDataStore for the fetch-once / persist-to-localStorage behaviour.
// Bump the version below whenever llmData.json's content changes, to
// invalidate copies already cached in returning visitors' browsers.
export const useLlmDataStore = createDataStore(
    '/data/llmData.json',
    'llm-data-store',
    ['slugs', 'nextPage', 'relatedPages', 'suggestedCourses'],
    1
);
